<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .about {
    padding: utils.in_rem(4px);

    .description {
      &:not(.is-overlay) {
        padding-bottom: utils.in_rem(12px);
      }

      @include mixins.body2();
      text-align: left;
    }
  }
</style>

<script>
  // Shared components
  import TruncatedText from "@sourcewhale/shared/svelte-design-system/components/utils/TruncatedText.svelte";
  import CompanyInsightsContainer from "../CompanyInsightsContainer.svelte";
  import IconInformation from "../IconInformation.svelte";
  import VerboseInformation from "../VerboseInformation.svelte";
  // About components
  import Competitors from "./Competitors.svelte";
  import Parent from "./Parent.svelte";
  import Separator from "./Separator.svelte";
  // Store
  import { companyInsightsStore, isOverlayStore } from "../stores";

  // MAP is passed to IconInformation to determine which keys to show
  // from the companyInsightsStore object, along with the corresponding icons
  const MAP = {
    foundedYear: { icon: "far fa-hourglass-start", tooltip: "Year founded" },
    location: { icon: "far fa-location-pin", tooltip: "Location" },
    industries: { icon: "far fa-building", tooltip: "Industries" },
    employeeInfo: { icon: "far fa-user", tooltip: "Employees" },
    fundingTotal: { icon: "far fa-sack-dollar", tooltip: "Funding total" },
    revenueRange: { icon: "far fa-money-bill-1-wave", tooltip: "Revenue" },
    valuation: { icon: "far fa-chart-line-up", tooltip: "Valuation" },
  };

  // This is true if the description and any of the above keys are not present
  $: showEmptyState =
    !$companyInsightsStore ||
    ![...Object.keys(MAP), "description"].find(
      (key) => $companyInsightsStore[key]
    );
</script>

<CompanyInsightsContainer {showEmptyState}>
  <div class="about">
    {#if $companyInsightsStore?.parentCompany}
      {@const { name, logo } = $companyInsightsStore.parentCompany}
      <Parent {name} {logo} />
    {/if}
    <div class="description" class:is-overlay={$isOverlayStore}>
      <TruncatedText
        text={$companyInsightsStore?.description}
        limit={$isOverlayStore ? 500 : 200}
      />
    </div>
    {#if $isOverlayStore}
      <VerboseInformation item={$companyInsightsStore} {MAP} />
    {:else}
      <IconInformation item={$companyInsightsStore} {MAP} />
    {/if}
    {#if $companyInsightsStore?.competitors}
      {#if !$isOverlayStore}
        <Separator />
      {/if}
      <Competitors competitors={$companyInsightsStore.competitors} />
    {/if}
  </div>
  <span slot="noCompanyInfo"> No company information found </span>
</CompanyInsightsContainer>
